// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modeBtn[data-v-cd877fc6]{padding:3px 10px;font-weight:400}.modeBtn.help[data-v-cd877fc6]{color:#fff;background-color:#739dd2}.modeBtn.help[data-v-cd877fc6]:hover{background-color:#9ab8de}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
